
import React, { useEffect } from 'react';
import "../styles/global.styles.css"
const BellIcon = () => {

    useEffect(() => {
    const bell = document.getElementById('bell-svg');
    const audio = document.getElementById('bell-audio');
    if (bell && audio) {
      const playSound = () => {
        audio.currentTime = 0;
        audio.play();
      };
      bell.addEventListener('animationiteration', playSound);
      return () => {
        bell.removeEventListener('animationiteration', playSound);
      };
    }
  }, []);
    
    return (
        <>
        <audio id="bell-audio" src="/sounds/bell.mp3" preload="auto">
            <track kind="captions" srcLang="en" label="Bell sound captions" />
        </audio>
        <svg
            width="16"
            height="auto"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '-5px', marginTop: '-10px' }}
            className="bell-animate"
        >
            <g clipPath="url(#clip0_840_1672)">
                <path
                    d="M19.7946 16.0806C19.2122 15.55 18.7022 14.9418 18.2785 14.2722C17.816 13.348 17.5387 12.3388 17.4631 11.3036V8.25476C17.4671 6.62887 16.8899 5.05745 15.8399 3.83575C14.7899 2.61404 13.3395 1.82614 11.7611 1.62009V0.823933C11.7611 0.605412 11.6761 0.395842 11.5249 0.241324C11.3737 0.086807 11.1686 0 10.9547 0C10.7408 0 10.5357 0.086807 10.3845 0.241324C10.2333 0.395842 10.1483 0.605412 10.1483 0.823933V1.63244C8.58405 1.85334 7.15112 2.646 6.11495 3.8636C5.07878 5.0812 4.50957 6.64123 4.51275 8.25476V11.3036C4.4371 12.3388 4.15987 13.348 3.69732 14.2722C3.28107 14.9402 2.77931 15.5484 2.20537 16.0806C2.14094 16.1384 2.0893 16.2096 2.05389 16.2894C2.01848 16.3692 2.00011 16.4558 2 16.5435V17.3828C2 17.5465 2.06364 17.7035 2.17692 17.8192C2.29019 17.935 2.44383 18 2.60403 18H19.396C19.5562 18 19.7098 17.935 19.8231 17.8192C19.9364 17.7035 20 17.5465 20 17.3828V16.5435C19.9999 16.4558 19.9815 16.3692 19.9461 16.2894C19.9107 16.2096 19.8591 16.1384 19.7946 16.0806ZM3.25638 16.7656C3.81837 16.2109 4.31318 15.5893 4.7302 14.9141C5.31285 13.7979 5.65281 12.5664 5.72685 11.3036V8.25476C5.70289 7.53145 5.82163 6.81061 6.076 6.13516C6.33037 5.45972 6.71516 4.84348 7.20746 4.32315C7.69977 3.80282 8.28952 3.38903 8.94159 3.10643C9.59366 2.82382 10.2947 2.67819 11.003 2.67819C11.7113 2.67819 12.4124 2.82382 13.0645 3.10643C13.7165 3.38903 14.3063 3.80282 14.7986 4.32315C15.2909 4.84348 15.6757 5.45972 15.93 6.13516C16.1844 6.81061 16.3032 7.53145 16.2792 8.25476V11.3036C16.3532 12.5664 16.6932 13.7979 17.2758 14.9141C17.6929 15.5893 18.1877 16.2109 18.7497 16.7656H3.25638Z"
                    fill="#C80000"
                />
                <path
                    d="M11.038 19.9999C11.5171 19.9935 11.9768 19.8897 12.3358 19.7067C12.6949 19.5237 12.9301 19.2734 13 19H9C9.07184 19.2808 9.31812 19.537 9.69301 19.7209C10.0679 19.9049 10.5459 20.004 11.038 19.9999Z"
                    fill="#C80000"
                />
            </g>
            <defs>
                <clipPath id="clip0_840_1672">
                    <rect width="21" height="21" fill="white" />
                </clipPath>
            </defs>
        </svg>
        </>
    );
};

export default BellIcon;
